<script>
  import http from '@/service/http'
  import { mapState } from 'vuex'
  import findIndex from 'lodash/findIndex'
  import { ListSelect } from 'vue-search-select'

  export default {
    name: 'Form',
    components: {
      ListSelect
    },
    data () {
      return {
        produtos: [],
        item: {
          id: '',
          produto: {},
          valor: '',
          qtd: ''
        },
        servico: {
          id: '',
          servico: '',
          descricao: '',
          observacao: '',
          valor: '',
          ativo: true,
          produtos: []
        },
        editorOption: {
          placeholder: 'Descrição',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              ['clean']
            ]
          }
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      },
      hasAll () {
        if (this.hasAll) {
          this.all = true
        } else {
          this.all = false
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/servicos' : `/servicos/${this.servico.id}`
        const {data} = await
          http[verb](url, this.servico)
        if (data != null) {
          this.$emit('update-servicos-list', {servico: data.servico})
          this.$router.push({name: 'servicos.index'})
        }
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await
            http.get(`/servicos/${id}/edit`)
          this.servico = data.servico
          this.produtos = data.produtos
        } else {
          const {data} = await
            http.get(`/servicos/create`)
          this.produtos = data.produtos
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      clear () {
        this.servico = {
          id: '',
          servico: '',
          descricao: '',
          valor: '',
          observacao: '',
          ativo: true,
          produtos: []
        }
      },
      onSelectProduto (item) {
        if (item) {
          const index = findIndex(this.servico.produtos, {produto_id: item.id})
          if (index > -1) {
            window.Materialize.toast(`${item.produto} já faz parte da proposta`, 2000)
          } else {
            const produto = {
              produto_id: item.id,
              produto: item,
              valor: item.valor_venda,
              quantidade: 1
            }
            this.addProduto(produto)
          }
        }
      },
      async addProduto (produto) {
        if (typeof this.servico.produtos === 'undefined') {
          this.servico.produtos = []
        }
        await
          this.servico.produtos.push(produto)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      destroyProduto (index) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um produto é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(async () => {
          if (!this.servico.produtos[index].id) {
            this.servico.produtos.splice(index, 1)
            window.Materialize.toast('Produto excluído!', 4000)
          } else {
            await http.delete(`servicos/produtos/${this.servico.produtos[index].id}`)
            this.servico.produtos.splice(index, 1)
            window.Materialize.toast('Produto excluído!', 4000)
          }
        })
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.servico.id === ''
      }
    }
  }
</script>

<template>
  <div>

    <form>

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div>

            <div class="row">
              <div class="input-field col s12 m8">
                <input name="servico" id="servico" type="text" v-validate
                       data-vv-rules="required" :class="{invalid: errors.has('servico')}"
                       v-model="servico.servico">
                <label for="servico">*Serviço</label>
                <small class="red-text">{{ errors.first('servico') }}</small>
              </div>
              <div class="input-field col s12 m4">
                <input name="valor" id="valor" type="number" v-validate step="any"
                       data-vv-rules="required" :class="{invalid: errors.has('valor')}"
                       v-model="servico.valor">
                <label for="valor">*Valor</label>
                <small class="red-text">{{ errors.first('valor') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="input-field col s12">
                <input name="observacao" id="observacao" type="text" v-validate :class="{invalid: errors.has('observacao')}"
                       v-model="servico.observacao">
                <label for="observacao">Observação</label>
                <small class="red-text">{{ errors.first('observacao') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="col s12">
                <!--<textarea name="descricao" class="materialize-textarea" id="descricao"-->
                <!--v-model="servico.descricao"></textarea>-->
                <!-- quill-editor -->
                <label>Descrição</label>
                <quill-editor ref="servico.descricao"
                              v-model="servico.descricao"
                              :options="editorOption">
                </quill-editor>
                <small class="red-text">{{ errors.first('descricao') }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <list-select :list="produtos"
                           option-value="id"
                           option-text="produto"
                           :selected-item="item"
                           placeholder="Adicionar Produto"
                           @select="onSelectProduto">
              </list-select>
            </div>
          </div>

          <div class="row" v-show="servico.produtos.length > 0">
            <div class="col s12">
              <table class="responsive-table bordered highlight">
                <thead>
                <tr>
                  <th>Produto</th>
                  <th width="10">Quantidade</th>
                  <th class="right-align">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(produto, index) in servico.produtos">
                  <td>
                    <p>{{ (produto.produto) ? produto.produto.produto : '-' }}</p>
                  </td>
                  <td>
                    <input type="number" :id="`quantidade${index}`" v-model="produto.quantidade" min="1"
                           style="margin-bottom: 0">
                  </td>
                  <td>
                    <div class="right-align">
                      <a href="#" @click.prevent="destroyProduto(index)">
                        <i class="material-icons red-text">delete_forever</i>
                      </a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12 m2">
              <input name="ativo" id="ativo" type="checkbox" v-model="servico.ativo">
              <label for="ativo">Ativo</label>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <button type="button" class="waves-effect waves-light btn" @click="validate" :disabled="loading">Salvar
              </button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/servicos/form.vue